import React from 'react';
import Sections from './sections';

const PagebuilderAfterContent = ({ pagebuilderSectionsAfterContent = [] }) => {
  if ((pagebuilderSectionsAfterContent || []).length === 0) {
    return null;
  }
  return (
    <Sections sections={pagebuilderSectionsAfterContent} />
  );
};

export default PagebuilderAfterContent;
